<template>
  <VoteBase>
    <template v-slot:voteMain>
      <b-form-group label="APP ID" label-for="app_id">
        <b-form-input id="app_id" type="text" v-model="app_id" />
      </b-form-group>
      <b-form-group label="手机号" label-for="phone">
        <b-form-input id="phone" type="text" v-model="phone" />
      </b-form-group>
      <b-form-group label="验证码" label-for="authcode">
        <b-form-input id="authcode" type="text" v-model="authcode" />
      </b-form-group>
      <b-form-group label="投票ID" label-for="voteId">
        <b-form-input id="voteId" type="text" v-model="voteId" />
      </b-form-group>
      <b-form-checkbox
        id="checkbox-1"
        v-model="yidun"
        name="checkbox-1"
      >
        开启易盾
      </b-form-checkbox>
      <b-button size="sm" class="mr-2" @click="getPhoneCode">获取验证码</b-button>
      <b-button size="sm" class="mr-2" @click="phoneLogin">登录</b-button>
      <b-button size="sm" class="mr-2" @click="vote">点赞</b-button>
      {{ result }}
    </template>
  </VoteBase>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import VoteBase from './Base'
import utils from '@/utils/utils'

export default {
  name: 'TestLoginAndVote',
  mixins: [Error],
  components: {VoteBase},
  data () {
    return {
      result: '',
      app_id: '',
      phone: '',
      authcode: '',
      voteId: '',
      yidun: false,
      wm: null
    }
  },
  created () {
    this.$ajax.jsonp = (url) => {
      if (!url) {
        console.error('请传入一个url参数')
        return
      }
      return new Promise((resolve, reject) => {
        window.jsonCallBack = (result) => {
          resolve(result)
        }
        var JSONP = document.createElement('script')
        JSONP.type = 'text/javascript'
        JSONP.src = `${url}&callback=jsonCallBack`
        document.getElementsByTagName('head')[0].appendChild(JSONP)
        setTimeout(() => {
          document.getElementsByTagName('head')[0].removeChild(JSONP)
        }, 500)
      })
    }
  },
  mounted () {
    let that = this
    initWatchman({
      productNumber: 'YD00743077964596',
      onload: function (instance) {
        that.wm = instance
      }
    })
  },
  methods: {
    getPhoneCode () {
      let params = {
        app_id: this.app_id,
        phone: this.phone
      }
      this.$ajax.jsonp(api.getVotePhoneCode() + utils.urlEncode(params)).then((res) => {
        this.result = JSON.stringify(res)
      })
    },
    phoneLogin () {
      let params = {
        app_id: this.app_id,
        phone: this.phone,
        authcode: this.authcode
      }
      this.$ajax.jsonp(api.getVotePhoneLogin() + utils.urlEncode(params)).then((res) => {
        this.result = JSON.stringify(res)
      })
    },
    vote () {
      let params = {
        app_id: this.app_id,
        vote_id: this.voteId
      }
      if (this.yidun) {
        let that = this
        this.wm && this.wm.getToken('780a97f2566b43ac85692f8250ee44c3', function (token) {
          // 提交点赞业务请求
          console.log(token)
          params['token'] = token
          that.$ajax.jsonp(api.getUserVote() + utils.urlEncode(params)).then((res) => {
            that.result = JSON.stringify(res)
          })
        })
      } else {
        this.$ajax.jsonp(api.getUserVote() + utils.urlEncode(params)).then((res) => {
          this.result = JSON.stringify(res)
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TestLoginAndVote.vue?9c201fe0